import { Select } from 'antd';
import React from 'react';
import { FallDetectAlgorithmNos } from '../constants';

function SelectFallDetectAlgorithm({ value, onChange, ...other }) {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder="Select an algorithm"
      allowClear
      {...other}
    >
      {Object.values(FallDetectAlgorithmNos).map((field) => (
        <Select.Option key={field.key} value={field.key}>
          {field.label}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SelectFallDetectAlgorithm;
